import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let MyCourse = class MyCourse extends Vue {
    async mounted() {
        if (this.tags && this.tags.length > 0) {
            let tagEl = this.$refs['tags'];
            if (tagEl) {
                let outerW = tagEl.offsetWidth;
                let childs = [...tagEl.childNodes];
                let c1 = childs[0].offsetWidth;
                let c2 = childs[1] ? childs[1].offsetWidth : 0;
                let childW = c1 + c2;
                if (childs.length === 3) {
                    if (childW + 15 - outerW > 0) {
                        childs[2].remove();
                    }
                }
            }
        }
    }
};
tslib_1.__decorate([
    Prop({ default: [] })
], MyCourse.prototype, "tags", void 0);
tslib_1.__decorate([
    Prop()
], MyCourse.prototype, "align", void 0);
MyCourse = tslib_1.__decorate([
    Component({})
], MyCourse);
export default MyCourse;
